import React from "react";
import { Link } from "react-router-dom";
import lockedimg from "../images/account_locked.svg";
import { INITIAL_ROUTE, SIGNIN_ROUTE } from "../constants/RoutePath";

export default function AccountLocked(props) {
  return (
    <div style={{ background: "#fff" }} id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <img
            style={{
              maxWidth: "343.933px",
              width: "100%",
              marginTop: "-35px",
            }}
            src={lockedimg}
          />
          <h1 style={{ marginTop: "-44px" }} className="not-found-title">
            Account Locked
          </h1>
          <p className="not-found-text">
            You have reached the maximum number of login attempts. For your
            security, your account has been locked.
            <br />
            <span>Please try again after 24 hours.</span>
            <br />
            If you need immediate assistance, please contact our support team at{" "}
            <a
              href="mailto:info@hosresources.com"
              style={{ color: "#58a84a", textDecoration: "underline" }}
            >
              info@hosresources.com
            </a>
          </p>
          <Link
            style={{ marginTop: "20px" }}
            className="back-to-homebtn"
            to={SIGNIN_ROUTE}
          >
            Back To Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
